var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-container"},[(_vm.loading_users)?_c('LoadingSpinner'):_c('div',{staticClass:"col-md-12 px-0 mx-0 table-responsive"},[_c('Table',{key:3232323,staticClass:"mx-2 w-100",attrs:{"headers":_vm.headers,"cols":_vm.cols,"data":_vm.users,"checkbox":false,"notselect":true,"model":_vm.model}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }